import { zendeskSsoLogin, wixSsoLogin } from './api';

export const getWixRedirectUrl = async ({ accessToken, wixRedirectUrl }) => {
  const response = await wixSsoLogin({
    token: accessToken.accessToken,
    redirectUrl: wixRedirectUrl,
  });
  return response?.data?.wixRedirectWithToken;
};

export const getZendeskRedirectUrl = async ({
  accessToken,
  zendeskRedirectUrl,
}) => {
  const response = await zendeskSsoLogin({
    token: accessToken.accessToken,
    redirectUrl: zendeskRedirectUrl,
  });
  return response?.data;
};
